enum EmailContext {
  All = 0,
  Meeting = 1,
  Finance = 2,
}

export default EmailContext;
